<template>
  <div style="width: 100%;height: 100%">
      <div style="height: 8%;position:relative;">
        <div style="font-size: 26px;font-weight: bolder;margin-left: 42%">验收意见或第三方评价</div>
      </div>
      <!-- 自定义toolar -->
      <div style="width: 100%;height: 80%;padding-left: 3%;box-sizing: border-box;margin-bottom: 5%">
        <div id="toolbar" slot="toolbar" style="background-color: white">
          <!-- Add a bold button -->
          <button class="ql-bold" title="加粗">Bold</button>
          <button class="ql-italic" title="斜体">Italic</button>
          <button class="ql-underline" title="下划线">underline</button>
          <button class="ql-strike" title="删除线">strike</button>
          <button class="ql-blockquote" title="引用"></button>
          <button class="ql-code-block" title="代码"></button>
          <button class="ql-header" value="1" title="标题1"></button>
          <button class="ql-header" value="2" title="标题2"></button>
          <!--Add list -->
          <button class="ql-list" value="ordered" title="有序列表"></button>
          <button class="ql-list" value="bullet" title="无序列表"></button>
          <!-- Add font size dropdown -->
          <select class="ql-header" title="段落格式">
            <option selected>段落</option>
            <option value="1">标题1</option>
            <option value="2">标题2</option>
            <option value="3">标题3</option>
            <option value="4">标题4</option>
            <option value="5">标题5</option>
            <option value="6">标题6</option>
          </select>
          <select class="ql-size" title="字体大小">
            <option value="10px">10px</option>
            <option value="12px">12px</option>
            <option value="14px">14px</option>
            <option value="16px" selected>16px</option>
            <option value="18px">18px</option>
            <option value="20px">20px</option>
          </select>
          <select class="ql-font" title="字体">
            <option value="SimSun">宋体</option>
            <option value="SimHei">黑体</option>
            <option value="Microsoft-YaHei">微软雅黑</option>
            <option value="KaiTi">楷体</option>
            <option value="FangSong">仿宋</option>
            <option value="Arial">Arial</option>
          </select>
          <!-- Add subscript and superscript buttons -->
          <select class="ql-color" value="color" title="字体颜色"></select>
          <select class="ql-background" value="background" title="背景颜色"></select>
          <select class="ql-align" value="align" title="对齐"></select>
          <button class="ql-clean" title="还原"></button>
<!--          <button class="ql-image" title="图片"></button>-->

        </div>
        <quill-editor
          :disabled="isDisabled"
          style="width: 100%;height: 100%;background-color: white"
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @focus="onEditorFocus($event)"
          @blur="onEditorBlur($event)"
          @change="onEditorChange($event)">
        </quill-editor>
        <span style="float: right">全文{{contentLength}}字</span>
      </div>
      <div v-if="!isDisabled" style="width: 100%;">
        <el-button type="info" @click="onReset" style="margin-left: 45%">重置</el-button>
        <el-button  type="primary" @click="onSubmit" :disabled="isDisabledSubmit">保存</el-button>
        <!--      <el-button v-if="isShowSave" type="primary" @click="onSubmit">保存</el-button>-->
        <!--      <el-button v-if="isShowEdit" type="primary" @click="onSubmit">修改</el-button>-->
      </div>
  </div>

</template>

<script>
import utils from "../../js/utils";

export default {
  name: "ThirdPartyEvaluation_04",
  data() {
    return {
      // files: []
      createuserid: sessionStorage.getItem('createuserid'),
      isDisabled: sessionStorage.getItem('openWith')=='readOnly' ? true : false,
      content: '',
      editor: null,   // 富文本编辑器对象
      editorOption: { //  富文本编辑器配置
        modules: {
          toolbar: '#toolbar'
        },
        theme: 'snow',
        placeholder: '请输入正文'
      },
      contentLength:0,
      isDisabledSubmit:false
    }
  },
  methods: {
    /*getData() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectadjunc',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid')),
          type: '流程'
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.files = []
          resp.data.forEach(obj => {
            this.files.push({
              name: obj.oldname,
              url: this.getFileUrl(obj.name),
              aid: obj.aid
            })
          })
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleChange(file, fileList) {
      this.files = fileList
      this.handleUpload()
    },
    beforeRemove() {
    return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    handleRemove(file, fileList) {
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/deletefilelist',
        data: [file.aid],
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleUpload() {
      let formData = new FormData()
      this.files.filter(obj => obj.status == "ready").forEach((obj, index) => {
        formData.append('files', obj.raw)
      })
      formData.append('pbcid', sessionStorage.getItem('pbcid'))
      formData.append('type', '流程')
      formData.append('typerank', 8)
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/file/addfile',
        data: formData
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    handleDownload(file) {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/file/downloadfile',
        params: {
          aid: file.aid
        },
        responseType: 'blob'
      }).then(res => {
        // const filename = res.headers['content-disposition'].match(/filename=(.*)/)[1]
        const filename = file.name
        const blob = new Blob([res.data]);//处理文档流
        const alink = document.createElement('a');
        alink.style.display = 'none';
        alink.href = window.URL.createObjectURL(blob);
        alink.setAttribute('download', decodeURI(filename))
        document.body.appendChild(alink);
        alink.click();
        window.URL.revokeObjectURL(alink.href); // 释放URL 对象
        document.body.removeChild(alink);
      })
    }*/
    // js methods部分
    // 准备富文本编辑器
    onEditorReady(editor) {
      if(this.isDisabled){
        editor.enable(false)
      }
    },
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {
      if(this.isDisabled){
        editor.enable(false)
      }
    },
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {
      if(this.isDisabled){
        editor.enable(false)
      }
    },
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.contentLength = editor.quill.getLength()-1
    },
    getData() {
      if(sessionStorage.getItem("pbcid")==undefined){
        return
      }
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectprojectotherevaluate',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid'))
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.content = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onSubmit(){
      this.openLoading("内容提交中","提交失败，请检查网络",7000)
      // this.isDisabledSubmit=true
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/user/addorupdateprojectotherappraise',
        data: {
          pbcid:sessionStorage.getItem('pbcid'),
          otherappraise:this.content,
        }
      }).then(res=>{
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        this.closeLoading()
        // this.isDisabledSubmit=false
        if(resp.code ==1000){
          this.showSuccessMsg(resp.message)
        }else{
          this.showFailMsg(resp.message)
        }
      })
    },
    onReset(){
      this.content = ''
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    this.editor = this.$refs.myQuillEditor.quill;
    if(sessionStorage.getItem('pbcid')==undefined){
      this.$message.error('请先填写项目基本情况表');
      this.$router.push({
        path:'/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
      })
    }

  }
}
</script>
<style>

</style>
<style scoped>
/deep/ .el-scrollbar__wrap {
  overflow: hidden scroll;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/ThirdPartyEvaluation_04.vue